<script setup lang="ts">
import { computed, ref } from 'vue'
import { api, extractError } from '@/api/client'

const siteUrl = ref('')
const problemType = ref('fraud')
const description = ref('')
const status = ref<'idle' | 'processing' | 'success' | 'error'>('idle')
const message = ref('')

const charCount = computed(() => description.value.length)

const types = [
  { value: 'fraud', label: 'Мошенничество' },
  { value: 'miner', label: 'Майнер' },
  { value: 'malware', label: 'Вредоносное ПО' },
  { value: 'phishing', label: 'Фишинг' },
  { value: 'scam', label: 'Обман' },
  { value: 'other', label: 'Другое' },
]

async function submit() {
  status.value = 'processing'
  message.value = ''
  try {
    const { data } = await api.post<{ success: boolean; message?: string }>(
      '/api/user/complaint',
      {
        site_url: siteUrl.value.trim(),
        problem_type: problemType.value,
        problem_description: description.value.trim(),
      },
    )
    if (data.success) {
      status.value = 'success'
      message.value = data.message || 'Жалоба отправлена'
      siteUrl.value = ''
      description.value = ''
      problemType.value = 'fraud'
    } else {
      status.value = 'error'
      message.value = data.message || 'Ошибка отправки'
    }
  } catch (e) {
    status.value = 'error'
    message.value = extractError(e)
  }
}
</script>

<template>
  <div class="mx-auto max-w-2xl">
    <h1 class="page-title mb-6">Пожаловаться на сайт</h1>

    <div class="panel">
      <div class="alert alert-warning mb-4 text-sm">
        Сообщите о мошеннических, фишинговых сайтах и других опасных ресурсах.
      </div>

      <form class="space-y-4" @submit.prevent="submit">
        <div>
          <label for="site-url">Ссылка на сайт</label>
          <input
            id="site-url"
            v-model="siteUrl"
            type="url"
            required
            class="form-input"
            placeholder="https://example.com"
          />
        </div>

        <div>
          <label for="problem-type">Тип проблемы</label>
          <select id="problem-type" v-model="problemType" class="form-select">
            <option v-for="t in types" :key="t.value" :value="t.value">
              {{ t.label }}
            </option>
          </select>
        </div>

        <div>
          <label for="description">Описание</label>
          <textarea
            id="description"
            v-model="description"
            rows="5"
            maxlength="5000"
            required
            class="form-textarea"
            placeholder="Подробно опишите проблему…"
          />
          <div class="mt-1 text-xs text-muted">{{ charCount }}/5000</div>
        </div>

        <button
          type="submit"
          class="btn btn-warning"
          :disabled="status === 'processing'"
        >
          {{ status === 'processing' ? 'Отправка…' : 'Отправить жалобу' }}
        </button>

        <div v-if="status === 'success'" class="alert alert-success">{{ message }}</div>
        <div v-if="status === 'error'" class="alert alert-danger">{{ message }}</div>
      </form>
    </div>
  </div>
</template>
